// @ts-nocheck
import find from 'lodash/find'
import { makeAutoObservable, action } from 'mobx'
import { COOKIES_MAP, USER_STORAGE, LOGIN_TAB_TYPE } from '@/constants'
import { isServer, getLoginStatus, getAcceptLocale, setUserLocale, formatUserInfo } from '@/utils'
import { getMenuAndButton } from '@/utils/authorized'
import config from '@/utils/config'
import eventBus from '@/utils/eventBus'
// import { userFirstLoginDate } from '@/utils/setUserFirstLoginDate'
import routes, { mergeOrderRoutes } from '@/utils/routes'
import {
  setStorage,
  // getStorage,
  getInitialValueFromStorage,
  clearStorageAll,
  setCookie,
  removeCookie,
} from '@/utils/storage'
import {
  setUserStorage,
  getUserStorage,
  getCorporationList,
  getCorporationChange,
  checkValidate,
} from '@/services/common'
import {
  login as loginApi,
  userCaptchaLogin,
  loginOut as loginOutApi,
  getUserEnterApplyInfo,
  userRegister,
  resetPassword,
} from '@/components/LoginModal/services'
// import { getCustomerOptionList } from './page-components/order/services'
import { HOME_PATH } from '@/constants'

interface corporationItemProps {
  businessAddress: string
  corporationId: number
  corporationName: string
  corporationType: number // 认证类型, 0个人账号，1公司，2个人主体
  creditStatus: number // 审批状态 (0未信审，1已信审，2授信过期，3认证失败)
  industryType: string
}

class GlobalStore {
  constructor() {
    makeAutoObservable(this)
    if (!isServer() && getLoginStatus()) {
      // 登录后，刷新时从本地存储读取数据初始化
      this.userInfo = getInitialValueFromStorage('user', {})
      const activeCorporationId = getInitialValueFromStorage('activeCorporationId')
      this.activeCorporationId = activeCorporationId ? activeCorporationId * 1 : null
      this.corporationList = getInitialValueFromStorage('corporationList', [])
      this.hasCorporation = getInitialValueFromStorage('hasCorporation')
      this.authorizedList = getInitialValueFromStorage('authorizedList', [])
      this.authorizedMenus = getInitialValueFromStorage('authorizedMenus', [])
      this.authorizedButtons = getInitialValueFromStorage('authorizedButtons', [])

      // this.refreshData(getStorage('activeCorporationId'))
    }
  }

  accessToken: string = '' // 请求token

  userInfo: any = {} // 用户数据

  channel: string = '' // 登录来源 正常、sso

  error: string = ''

  theme: string = 'dark' // 主题色

  loginModalVisible: boolean = false // 控制登录弹框是否显示

  loginCallback: (...args: any) => void | null = null // 登录后回调

  targetPathUrl: string = HOME_PATH // 跳转到的页面路径

  currentAction: string = 'login' // 当前处于的类型

  authorizedList: any = [] // 后端返回的权限菜单、按钮数据

  authorizedMenus: any = [] // 处理后的菜单权限数据

  authorizedButtons: any = [] // 处理后的按钮权限数据

  activeCorporationId: number | null // 选中的主体，退出时存储，再次登录获取上次身份id

  activeCorporationName: string // 选中时的主体名称

  corporationList: corporationItemProps[] = [] // 主体列表

  hasCorporation: boolean = false // 通过主体接口，判断是否显示创建团队入口

  corporationChangeling: boolean = false // 防止切换出现先派发的请求后返回数据

  corporationChangeMark: number = 0 // 配合上面设置正确的值

  loading: boolean = false // 全局loading

  routes: any = [...routes] // 本地全局路由

  checkValidateResult: boolean = false // 是否需要进行滑块验证

  lastLoginTab: string = LOGIN_TAB_TYPE.CODE // 最后选中的登录tab，记录用户行为

  isNewDevice: boolean = false // 是否新设备

  // firstLoginDate: string = '' // 用户首次登录日期

  memberReceiveShow: number = 0 // 自动领取会员弹框表示

  /**
   * 获取token信息
   * @returns
   */
  getToken() {
    return this.userInfo.token
  }

  /**
   * 获取pu token
   * @returns
   */
  getChannelToken() {
    return this.userInfo.channelToken
  }

  /**
   * user 主体id
   * @returns
   */
  getUserCorporationId() {
    const record = find(this.corporationList, { corporationType: 0 })
    return record?.corporationId || 0
  }

  /**
   * 重置数据
   */
  resetGlobal = () => {
    this.corporationList = []
    this.authorizedList = []
    this.authorizedMenus = []
    this.authorizedButtons = []
    this.activeCorporationId = null
    this.activeCorporationName = ''
    this.hasCorporation = false
    this.corporationChangeling = false
    this.corporationChangeMark = 0
    ;(this.isNewDevice = false), (this.routes = [...routes])
  }

  /**
   * 更新 store数据
   * @param key
   * @param value
   */
  updateGlobalStore = (key: string, value: any) => {
    this[key] = value
  }

  /**
   * 设置身份id
   * @param corporationId
   * @returns
   */
  changeLastCorporationId = async (corporationId: number) => {
    try {
      if (!corporationId) {
        // console.log('没有corporationId 无法设置身份缓存')
        return
      }
      const key = `${this?.userInfo?.id}-last-corporation-id`
      await setUserStorage({
        key,
        value: corporationId,
      })
    } catch (error) {
      console.error('设置身份缓存失败: ', error)
    }
  }

  /**
   * 获取身份id
   * @param id
   * @returns
   */
  getLastCorporationId = async (id: number) => {
    try {
      const key = `${id}-last-corporation-id`
      const { data } = await getUserStorage({
        keys: [key],
      })
      if (data?.code === 0 && data?.result?.[key]) {
        this.activeCorporationId = data?.result?.[key] * 1 || null
      }
      return this.activeCorporationId
    } catch (error) {
      console.error('获取身份缓存失败: ', error)
    }
  }

  /**
   * 更新当前主题id和名称
   * @param param
   */
  updateCorporationInfo = (param: any = {}) => {
    this.activeCorporationId = param.corporationId || this.getUserCorporationId() || null
    const record = find(this.corporationList, { corporationId: this.activeCorporationId }) || {
      corporationName: '',
    }
    setStorage('activeCorporationId', this.activeCorporationId)
    this.activeCorporationName = record?.corporationName || ''
  }

  /**
   * 判断当前角色是否个人账号
   * @param id
   * @returns
   */
  getIsPersonal(id?: number) {
    // corporationType: 0-个人账号，1-公司，2-个人主体
    const record = find(this.corporationList, { corporationId: id || this.activeCorporationId })
    return !record?.corporationType
  }

  /**
   * 初始化站点语言
   */
  initSiteLocale = async (isRegister?: boolean = false) => {
    const acceptLocale = getAcceptLocale()
    if (!acceptLocale) return
    if (!isRegister) {
      // 非注册
      const { data: localeStorageData } = await getUserStorage({
        keys: [USER_STORAGE.LOCALE],
      })
      if (localeStorageData?.code === 0) {
        const localeResult = localeStorageData?.result || {}
        const serveStorageLocale = localeResult[USER_STORAGE.LOCALE]
        if (!serveStorageLocale) {
          // 个性化语言未设置，使用浏览器语言
          await setUserStorage({
            key: USER_STORAGE.LOCALE,
            value: acceptLocale,
          })
          setUserLocale(acceptLocale)
        } else {
          // 已设置个性化语言
          setUserLocale(serveStorageLocale)
        }
      }
    } else {
      // 注册，直接初始化语言
      await setUserStorage({
        key: USER_STORAGE.LOCALE,
        value: acceptLocale,
      })
      setUserLocale(acceptLocale)
    }
  }

  /**
   * 获取用户信息
   */
  queryUser = async () => {
    const { data } = await getUserEnterApplyInfo()
    if (data?.code === 0) {
      const info = data?.result || {}
      const userInfo = formatUserInfo(info)
      window?.DATAFLUX_RUM?.setUser({
        id: `${userInfo.id}`,
        name: userInfo.nickName,
        email: userInfo.email,
      })
      // cb pu中使用
      setStorage('user', userInfo)
      this.userInfo = userInfo
      return Promise.resolve(userInfo || {})
    }
    return Promise.resolve({})
  }

  /**
   * 获取用户信息
   */
  updateUserInfo = (userInfo: any) => {
    this.userInfo = formatUserInfo(userInfo)
    setStorage('user', this.userInfo)
  }

  /**
   * 获取主体列表(包含切换主题)
   * @param id
   * @param changable
   * @returns
   */
  fetchCorporationList = async (id?: number | null, changable: boolean = true) => {
    try {
      const { data } = await getCorporationList()
      if (data?.code === 0) {
        const cps = data?.result?.corporationList || []
        this.corporationList = cps
        this.hasCorporation = !!data?.result?.hasCorporation
        setStorage('corporationList', this.corporationList)
        setStorage('hasCorporation', this.hasCorporation)

        const corporationId =
          id || (this.getIsPersonal() ? this.getUserCorporationId() : this.activeCorporationId)
        if (id) {
          // 切换菜单时需要对this.activeCorporationId 赋值
          this.activeCorporationId = id
        }
        const isPersonal: boolean = this.getIsPersonal(corporationId)
        this.routes = [...routes]

        /**
         * 放在这里请求的原因是需要等主体返回后，取用户user 的主体ID（第一次user 身份登录时）
         * 参数：登录时没有id 需判断，切换时有主体id
         */
        if (changable) {
          // 注册执行的不调用
          const corporationRecord =
            find(this.corporationList, {
              corporationId: this.activeCorporationId,
            }) || {}
          const params: any = {
            corporationType: corporationRecord?.corporationType,
            corporationName: corporationRecord?.corporationName || '',
            corporationId,
          }
          if (isPersonal) {
            params.corporationId = null
          }
          return this.fetchCorporationChange(params)
        }
        this.updateCorporationInfo({})
        this.loading = false
        return Promise.resolve(data || {})
      }
      return Promise.resolve(data || {})
    } catch (error) {
      console.error('获取主体列表失败 ', error)
      this.loading = false
      return Promise.resolve({})
    }
  }

  /**
   * 登录、切换用户主体，获取权限列表 isChange: 是否是切换
   * @param param
   * @returns
   */
  fetchCorporationChange = async (params: any) => {
    const localMark = ++this.corporationChangeMark
    try {
      const { data } = await getCorporationChange(params)
      this.corporationChangeling = false
      const code = data?.code
      // 防止先派发的请求后回来，导致状态错误
      if (code === 0 && localMark === this.corporationChangeMark) {
        // 赋值主体id、名称
        this.updateCorporationInfo(params)
        const { permissionList, userInfo } = data?.result || {}
        // 更新用户中的会员相关信息
        this.userInfo = formatUserInfo(userInfo)
        setStorage('user', this.userInfo)
        this.authorizedList = permissionList
        // 处理权限数据
        const { menus, buttons } = getMenuAndButton(permissionList)
        this.authorizedMenus = menus
        this.authorizedButtons = buttons
        setStorage('authorizedList', permissionList)
        setStorage('authorizedMenus', menus)
        setStorage('authorizedButtons', buttons)
        // 为下次登录设置上次身份id
        this.changeLastCorporationId(this.activeCorporationId)
        // 切换成功导向到视频列表页面,在页面执行路由切换操作
        return data
      }
      // 主体找不到关联关系，如删除，则使用user 身份对应的主体进行设置
      if (code === 210191005) {
        const currentUserCorporationId = this.getUserCorporationId()
        this.activeCorporationId = currentUserCorporationId
        this.changeLastCorporationId(currentUserCorporationId)
      }
      this.loading = false
    } catch (error) {
      console.error('切换用户主体失败', error)
      this.loading = false
      this.corporationChangeling = false
    }
  }

  /**
   * 刷新用户信息、身份、权限在主体请求中调用
   * @param activeCorporationId
   * @param refreshUserInfo
   * @returns
   */
  refreshData = (activeCorporationId?: any, refreshUserInfo?: boolean = true) => {
    this.loading = true
    try {
      if (!refreshUserInfo) {
        return Promise.all([this.fetchCorporationList(activeCorporationId)])
      }
      return Promise.all([this.fetchCorporationList(activeCorporationId), this.queryUser()])
    } catch (e) {
      console.error('切换主体刷新批量调用接口失败: ', e)
      return Promise.resolve([{}, {}])
    }
  }

  /**
   * 登录框唤起
   * @param visible
   * @param cb
   */
  loginModalToggle(visible = true, cb?: () => void) {
    if (visible) {
      this.loginModalVisible = true
      if (cb) {
        this.loginCallback = cb
      }
    } else {
      this.loginModalVisible = false
      this.targetPathUrl = HOME_PATH
      this.loginCallback = null
    }
  }

  /**
   * 登录
   * @param params
   * @param callback
   * @param type  是手机验证码登录还是账号密码登录
   * @returns
   */
  login = async (
    params: any,
    type?: 'mobile' | 'account',
    callback?: (targetUrl: string) => any,
  ) => {
    this.loading = true
    try {
      let responseData
      if (type === 'mobile') {
        responseData = await userCaptchaLogin(params)
      } else {
        responseData = await loginApi(params)
      }
      const { data } = responseData
      if (data?.code === 0) {
        const userInfo: any = formatUserInfo(data.result || {})
        const { token, id, isBindTag, phone, email, nickName } = userInfo
        // 设置用户信息
        setStorage('user', userInfo)
        // 缓存token
        setCookie(token)
        // 设置引导状态-已提交
        isBindTag && setCookie('1', COOKIES_MAP.USER_FAVORITE)
        // 设置用户语言
        await this.initSiteLocale()
        window?.DATAFLUX_RUM?.setUser({
          id: `${id}`,
          name: nickName,
          email,
        })
        window?.gio?.('setUserId', `${id}`)
        window?.gio?.('people.set', {
          phone,
          email,
        })
        // 用户信息
        this.userInfo = userInfo
        // 获取上次身份，这里需要上次身份获取完了以后再取主体，否则无法判断第一次高亮user
        const lastCorporationId = (await this.getLastCorporationId(id)) || 0
        if (lastCorporationId) {
          setStorage('activeCorporationId', lastCorporationId)
        }
        // 获取主体列表
        await this.fetchCorporationList()
        // 登录后一些操作执行：如收藏、分享转存弹框的唤起等...
        this.loginCallback?.(userInfo)
        // 全局通知登录成功
        eventBus.emit('loginSuccess')
        // 以下执行顺序勿调整
        const targetPathUrl = this.targetPathUrl
        // 关闭弹框需要放在最后执行
        this.loginModalToggle(false)
        // 已绑定的用户，不需要跳转引导页
        const newRes = { ...(data || {}), lastCorporationId }
        callback?.(newRes, targetPathUrl)
        return Promise.resolve({
          success: true,
          data: newRes,
        })
      }
      this.loading = false
      callback?.(responseData)
      return Promise.resolve({
        success: false,
        data: responseData,
      })
    } catch (e) {
      console.error('登录失败: ', e)
      this.loading = false
      callback?.(null)
      return Promise.resolve({
        success: false,
      })
    }
  }

  /**
   * 退出登录
   * @param history
   * @param resetLocale
   */
  loginOut = async (history: any, resetLocale?: (lang: string) => any) => {
    if (window.IMInstance?.loginout) {
      window.IMInstance.loginout?.()
    }
    const { data } = await loginOutApi({})
    if (data?.code === 0) {
      clearStorageAll()
      window?.gio?.('clearUserId')
      window?.DATAFLUX_RUM?.removeUser()
      removeCookie()
      const acceptLocale = getAcceptLocale()
      if (acceptLocale) {
        setUserLocale(acceptLocale)
      }
      resetLocale?.(acceptLocale)
      // 退出后清空url中的channel参数
      eventBus.emit('loginOutSuccess')
      this.userInfo = {}
      this.resetGlobal()
      // window.location.href = HOME_PATH
      history?.replace(HOME_PATH)
    }
  }

  // 用户注册
  register = async (params: any) => {
    this.loading = true
    try {
      const { data = {} } = await userRegister(params)
      if (data?.code === 0) {
        const userInfo: any = formatUserInfo(data.result || {})
        const { token, id, phone, email, nickName } = userInfo
        if (token) {
          window?.DATAFLUX_RUM?.setUser({
            id: `${id}`,
            name: nickName,
            email,
          })
          window?.gio?.('setUserId', `${id}`)
          window?.gio?.('people.set', {
            phone,
            email,
          })
          setCookie(token)
          setStorage('user', userInfo)
          this.userInfo = userInfo
          // 设置语言
          await this.initSiteLocale(true)
          // 请求主题列表
          await this.fetchCorporationList(null, false)
          // 设置首次登录日期
          // const { firstLoginDate } = await userFirstLoginDate()
          // this.firstLoginDate = firstLoginDate
          // 关闭弹框
          this.loginModalToggle(false)
          return Promise.resolve({
            success: true,
            data,
          })
        }
      }
      return Promise.resolve({
        success: false,
        data,
      })
    } catch (e) {
      console.error('注册失败: ', e)
      this.loading = false
      return Promise.resolve({
        success: false,
      })
    }
  }

  /**
   * 重置密码
   * @param params
   */
  resetPassword = async (params: any) => {
    try {
      const { data = {} } = await resetPassword(params)
      if (data?.code === 0) {
        // 切换成登录框
        this.currentAction = 'login'
        return Promise.resolve({
          success: true,
          data,
        })
      }
      return Promise.resolve({
        success: false,
        data,
      })
    } catch (e) {
      console.error('重置密码捕获错误: ', e)
      return Promise.resolve({
        success: false,
      })
    }
  }

  /**
   * 是否需要滑块验证码
   * @param params
   */
  checkValidateAjax = async (params: any) => {
    let checkValidateResult = this.checkValidateResult
    try {
      const { data = {} } = await checkValidate(params)
      if (data?.code === 0) {
        // 切换成登录框
        checkValidateResult = data.result
      }
    } catch (e) {
      console.error('滑块验证码捕获错误: ', e)
      checkValidateResult = false
    }
    this.checkValidateResult = checkValidateResult
    return checkValidateResult
  }
}

export default new GlobalStore()
